module.exports = __webpack_public_path__ + "static/media/iconCancell.5bc3c7bc.svg";